import axios from '../../../service/index'
import React, { Component } from 'react'
import { Form, Input, Select, Button, message } from 'antd'
import './server.less'

const { Option } = Select;
class ServerCard extends Component {
  state = {
    subjectOptions: [],
    typeTitel: 'add',
    infoObj: {},
    realName: '',
    phone: '',
    subjectId: '',
    userId: '',
    name: '',
    teaOptions: []
  }
  componentDidMount() {
    this.InitHandle()
    
    if(this.props.location.state){
      let {userId, name} = this.props.location.state
      this.setState({userId, name, realName: name})
    }
  }
  InitHandle() {
    axios.post('list').then(res => {
      if(res.data.code === '200'){
        this.setState({subjectOptions: res.data.data})
      }
    })
  }
  submitOk = (e) => {
    e.preventDefault()
    this.props.form.validateFields((err, values) => {
      if(!err){
        let {phone, realName, subjectId, subjectOptions, userId} = this.state
        let nameobj = subjectOptions.filter(c => c.id === subjectId)
        let params = {
          externalUserid: userId,
          phone,
          realName,
          subjectId: subjectId,
          subjectName: nameobj.length>0?nameobj[0].name:''
        }
        axios.post('addUserInfo',params).then(res => {
          if(res.data.code === '200') {
            message.success('提交成功')
            this.props.form.resetFields()
            
          }else{
            message.error(res.data.msg)
          }
          
        })
      }
    })
  }
  phoneValidateForm = (rule, value, callback) => {
    let rules = /^1(3|4|5|6|7|8|9)\d{9}$/
    if(value&&!rules.test(value)){
      callback('请输入正确的手机号')
    }else{
      callback()
    }
  }
  render() {
    let {subjectOptions, typeTitel, infoObj} = this.state
    let {getFieldDecorator} = this.props.form
    const formItemLayout = {
      labelCol: {
        xs: { span: 4 },
        sm: { span: 2 },
      },
      wrapperCol: {
        xs: { span: 20 },
        sm: { span: 22 },
      },
    }
    const btnLayout = {
      wrapperCol:{
        sm: { offset: 2, span: 22 }
      }
    }
    return (
      <div>
        <div className="server-card">
          <p className="title">填写学员服务卡</p>
          <Form {...formItemLayout} onSubmit={this.submitOk}>
						<Form.Item label="姓名" name="realName" placeholder="请输入姓名">
              {getFieldDecorator('realName', {
              rules: [
                {required: true, message: '请输入姓名'},
                {max: 20,message: '最多输入20个字!'}
              ]
            })(<Input onChange={(e) => {this.setState({realName: e.target.value})}} />)}
						</Form.Item>
            <Form.Item label="手机号" name="phone" placeholder="请输入手机号">
              {getFieldDecorator('phone', {
              rules: [
                {required: true, message: '请输入手机号'},
                { validator: this.phoneValidateForm }
              ]
            })(<Input onChange={(e) => {this.setState({phone: e.target.value})}} />)}
						</Form.Item>
            <Form.Item label="意向学科" name="subjectId">
              {getFieldDecorator('subjectId', {
              initialValue: typeTitel === 'edit'?infoObj.subjectId:''
            })(<Select placeholder="请选择" onChange={(e) => {this.setState({subjectId: e})}}>
              {subjectOptions.map(item=>{
                return (<Option key={item.id} value={item.id}>{item.name}</Option>)
              })}
            </Select>)}
						</Form.Item>
            <Form.Item {...btnLayout}>
            <Button className="submit-btn" type="primary" htmlType="submit">
              提交
            </Button>
            </Form.Item>
          </Form>
        </div>
      </div>
    )
  }
}
export default Form.create()(ServerCard)